(function () {
  // The site uses an AI-curated local dictionary with no external translation
  // runtime, tracking cookie, or client-side API key.
  var languages = [
    { code: "en", short: "EN", name: "English", country: "gb" },
    { code: "bg", short: "BG", name: "Български", country: "bg" },
    { code: "tr", short: "TR", name: "Türkçe", country: "tr" },
    { code: "ar", short: "AR", name: "العربية", country: "sa" },
    { code: "nl", short: "NL", name: "Nederlands", country: "nl" },
    { code: "fr", short: "FR", name: "Français", country: "fr" },
    { code: "de", short: "DE", name: "Deutsch", country: "de" },
    { code: "it", short: "IT", name: "Italiano", country: "it" },
    { code: "pt", short: "PT", name: "Português", country: "pt" },
    { code: "ru", short: "RU", name: "Русский", country: "ru" },
    { code: "es", short: "ES", name: "Español", country: "es" }
  ];
  function translations() { return window.mermerTranslations || {}; }
  // Static-bake mode: pages under /bg/ /tr/ ... are pre-translated at build
  // time and carry <meta name="mermer-static-lang">. The picker then works by
  // NAVIGATION (each language is its own URL) instead of live DOM translation.
  var staticLangMeta = document.querySelector('meta[name="mermer-static-lang"]');
  var staticLang = staticLangMeta ? staticLangMeta.content : null;
  var savedLanguage = window.localStorage.getItem("mermer-language");
  var currentLanguage = staticLang || savedLanguage || "en";
  var supported = languages.some(function (language) {
    return language.code === currentLanguage;
  });
  var originalText = new WeakMap();
  var originalAttributes = new WeakMap();
  var originalTitle = document.title;
  var description = document.querySelector('meta[name="description"]');
  var originalDescription = description ? description.content : "";

  if (!supported) currentLanguage = "en";
  window.__mermerPreferredLanguage = currentLanguage;

  function normalize(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function translate(source, language) {
    var normalized = normalize(source);
    if (!normalized || language === "en") return normalized;
    var dict = translations();
    return dict[language] && dict[language][normalized]
      ? dict[language][normalized]
      : normalized;
  }

  function shouldSkip(node) {
    var parent = node.parentElement;
    return (
      !parent ||
      parent.closest(
        "script, style, noscript, .notranslate, [data-i18n-ignore], .mermer-language-menu"
      )
    );
  }

  function applyTextNode(node, language) {
    if (shouldSkip(node)) return;
    if (!originalText.has(node)) originalText.set(node, node.nodeValue);

    var source = originalText.get(node);
    var normalized = normalize(source);
    if (!normalized) return;

    var translated = translate(normalized, language);
    var leading = source.match(/^\s*/)[0];
    var trailing = source.match(/\s*$/)[0];
    node.nodeValue = leading + translated + trailing;
  }

  function applyAttributes(element, language) {
    var attributes = ["placeholder", "aria-label", "title"];
    var saved = originalAttributes.get(element) || {};

    attributes.forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) return;
      if (!(attribute in saved)) saved[attribute] = element.getAttribute(attribute);
      element.setAttribute(attribute, translate(saved[attribute], language));
    });

    originalAttributes.set(element, saved);
  }

  function apply(root) {
    var language = currentLanguage;
    var scope = root || document.body;
    if (!scope) return;

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) applyTextNode(walker.currentNode, language);

    scope.querySelectorAll("[placeholder], [aria-label], [title]").forEach(function (element) {
      if (!element.closest(".notranslate, [data-i18n-ignore], .mermer-language-menu")) {
        applyAttributes(element, language);
      }
    });

    document.title = translate(originalTitle, language);
    if (description) description.content = translate(originalDescription, language);
    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    updateSwitcher();
  }

  function languageMarkup(language) {
    return (
      '<button type="button" class="mermer-language-option" role="option" ' +
      'data-language="' +
      language.code +
      '" aria-label="' +
      language.name +
      '" title="' +
      language.name +
      '" aria-selected="' +
      String(language.code === currentLanguage) +
      '">' +
      '<img class="language-flag" src="' + (window.YOPPY_ASSET_BASE || '/assets/flags/') + 'flag-' + language.country + '.png" width="24" height="18" alt="" aria-hidden="true">' +
      '<strong class="language-code">' +
      language.short +
      "</strong>" +
      "</button>"
    );
  }

  function renderSwitcher() {
    var wrapper = document.querySelector(".ai-language-wrapper");
    if (!wrapper) return;

    wrapper.innerHTML =
      '<div class="mermer-language-menu" data-i18n-ignore>' +
      '<button type="button" class="mermer-language-current" aria-haspopup="listbox" aria-expanded="false" aria-label="Choose language">' +
      '<img class="language-flag" width="24" height="18" alt="" aria-hidden="true">' +
      '<strong class="language-code"></strong>' +
      '<span class="language-arrow" aria-hidden="true">&#9652;</span>' +
      "</button>" +
      '<div class="mermer-language-options" role="listbox" hidden>' +
      languages.map(languageMarkup).join("") +
      "</div>" +
      "</div>";

    var menu = wrapper.querySelector(".mermer-language-menu");
    var trigger = menu.querySelector(".mermer-language-current");
    var options = menu.querySelector(".mermer-language-options");

    trigger.addEventListener("click", function () {
      var open = options.hidden;
      options.hidden = !open;
      trigger.setAttribute("aria-expanded", String(open));
    });

    options.addEventListener("click", function (event) {
      var option = event.target.closest("[data-language]");
      if (!option) return;
      setLanguage(option.dataset.language);
      options.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
    });

    document.addEventListener("click", function (event) {
      if (!menu.contains(event.target)) {
        options.hidden = true;
        trigger.setAttribute("aria-expanded", "false");
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !options.hidden) {
        options.hidden = true;
        trigger.setAttribute("aria-expanded", "false");
        trigger.focus();
      }
    });

    updateSwitcher();
  }

  function updateSwitcher() {
    var active = languages.find(function (language) {
      return language.code === currentLanguage;
    });
    var menu = document.querySelector(".mermer-language-menu");
    if (!active || !menu) return;

    var currentFlag = menu.querySelector(
      ".mermer-language-current .language-flag"
    );
    currentFlag.src = (window.YOPPY_ASSET_BASE || "/assets/flags/") + "flag-" + active.country + ".png";
    currentFlag.alt = "";
    menu.querySelector(".language-code").textContent = active.short;
    menu
      .querySelector(".mermer-language-current")
      .setAttribute("aria-label", "Choose language: " + active.name);
    menu.querySelectorAll("[data-language]").forEach(function (option) {
      option.setAttribute(
        "aria-selected",
        String(option.dataset.language === currentLanguage)
      );
    });
  }

  
  var loadedLangs = { en: true };
  function ensureDictionary(language, done) {
    if (language === "en" || (window.mermerTranslations && window.mermerTranslations[language])) { done(); return; }
    if (loadedLangs[language + "_loading"]) { done(); return; }
    loadedLangs[language + "_loading"] = true;
    var s = document.createElement("script");
    s.src = (window.YOPPY_I18N_BASE || "/assets/i18n/") + "i18n-" + language + ".js";
    s.onload = function () { done(); };
    s.onerror = function () { done(); };
    document.head.appendChild(s);
  }

  function setLanguage(language) {
    if (
      !languages.some(function (item) {
        return item.code === language;
      })
    ) {
      return;
    }

    currentLanguage = language;
    window.__mermerPreferredLanguage = language;
    window.localStorage.setItem("mermer-language", language);

    if (staticLang) {
      // Navigate to this page's copy in the chosen language.
      var file = window.location.pathname.split("/").pop() || "index.html";
      if (file === "index.html") file = "";
      window.location.href = language === "en" ? "/" + file : "/" + language + "/" + file;
      return;
    }

    ensureDictionary(language, function () {
      document.dispatchEvent(
        new CustomEvent("mermer:language-change", {
          detail: { language: language }
        })
      );
      apply();
    });
  }

  window.mermerI18n = {
    apply: apply,
    setLanguage: setLanguage,
    translate: function (source) {
      return translate(source, currentLanguage);
    },
    getLanguage: function () {
      return currentLanguage;
    }
  };

  renderSwitcher();
  if (currentLanguage !== "en" && !staticLang) {
    ensureDictionary(currentLanguage, function () { apply(); });
  } else {
    apply();
  }
})();
